import axios, { AxiosError } from 'axios';
import { CancelPrevRequestKey } from '.';
import { BaseError } from './error';

export function isIgnoreError(error: AxiosError) {
  if (error.config.ignoreError) {
    return true;
  }
  return false;
}

interface ErrorParam {
  status: string;
  code: string;
  url: string;
  message: string;
}

export function buildErrorMessage(params: ErrorParam) {
  return Object.keys(params)
    .reduce<string[]>((res, key) => {
      const value = params[key as keyof ErrorParam];
      if (value) {
        res.push(`${key}: ${value}`);
      }
      return res;
    }, [])
    .join(', ');
}

export function hash(value: string) {
  let hash = 0,
    i,
    chr;
  if (value.length === 0) return hash;
  for (i = 0; i < value.length; i++) {
    chr = value.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

export function createThrottlePool() {
  const cache: { [name: string]: () => void } = {};
  return function (hash: string, handler: () => void) {
    if (!cache[hash]) {
      cache[hash] = () => {
        handler();
        setTimeout(() => {
          delete cache[hash];
        }, 5000);
      };
      cache[hash]();
    }
  };
}

export function isCancelError(e: any, previous = false) {
  if (axios.isCancel(e)) {
    if (previous) {
      return e.message === CancelPrevRequestKey;
    } else {
      return true;
    }
  }
  return false;
}

export function isBaseError(e: any) {
  return e instanceof BaseError;
}
